module.exports = __webpack_public_path__ + "static/media/mobile_app.2703d9b6.png";